import React from 'react';
import PropTypes from 'prop-types';
import { ApplicationFormShell } from 'web-ui-components/lib/layout/shells';
import { PageHeading } from 'web-ui-components/lib/typography/headings';
import { NavigationButton } from 'web-ui-components/lib/navigation/buttons';
import { GenericDescriptionList } from 'web-ui-components/lib/data/lists';
import { StandardBody } from 'web-ui-components/lib/typography/body';
import { Inline } from 'web-ui-components/lib/layout/grids';
import {
  PAGE_CLAIM_AMOUNT,
  PAGE_DISPUTE_PAYMENT,
} from '../../../constants/FraudAndDisputeConstants';
import InternetBankingActions from '../../../actions/InternetBankingActions';
import AnalyticsUtil from '../../../utils/AnalyticsUtil';
import config from '../../../config';

export const ContactDetails = (props) => {
  const { content, setPage, userDetails } = props;
  const contactInfo = userDetails?.phone_numbers?.filter(
    (number) => number.preferred
  );
  const contactDetailsList = [
    {
      key: 'Mobile number',
      value: contactInfo[0]?.phone_number,
    },
    {
      key: 'Email address',
      value: userDetails?.email_addresses[0]?.value,
    },
  ];

  return (
    <ApplicationFormShell>
      <PageHeading>{content.contactDetailsTitle}</PageHeading>
      <StandardBody>
        <p>{content.contactDetailsText}</p>
        <p>{content.jointAccountUpdatesText}</p>
      </StandardBody>

      <GenericDescriptionList items={contactDetailsList} />
      <Inline.LeftAligned
        nodes={[
          <NavigationButton.Tertiary
            key="edit_contact_details"
            data-test-id="edit_contact_details"
            labelText={content.editContactDetails}
            onClick={() => {
              AnalyticsUtil.analyticAction(
                config.analytics.analytics_experience_activity,
                config.analytics.analytics_event_method_interacted,
                config.analytics.analytics_action_dispute_edit_contact_details,
                config.analytics.analytics_action_button_click
              );
              InternetBankingActions.navigateToWebTask(
                'WEB-MANAGE-PERSONAL-DETAILS'
              );
            }}
          />,
        ]}
      />
      <div className="button-group">
        <NavigationButton.Secondary
          data-test-id="back"
          labelText={content.back}
          onClick={() => {
            setPage(PAGE_DISPUTE_PAYMENT);
          }}
        />
        <NavigationButton.Primary
          labelText={content.continueButtonText}
          data-test-id="continue"
          onClick={() => {
            setPage(PAGE_CLAIM_AMOUNT);
            AnalyticsUtil.analyticAction(
              config.analytics.analytics_experience_activity,
              config.analytics.analytics_event_method_interacted,
              config.analytics.analytics_action_dispute_contact_details,
              config.analytics.analytics_action_button_click
            );
          }}
        />
      </div>
    </ApplicationFormShell>
  );
};

ContactDetails.propTypes = {
  content: PropTypes.object,
  setPage: PropTypes.func,
  userDetails: PropTypes.object,
};
